import Select, {createFilter} from "react-select";
import React, { useEffect, useState } from "react";
import "./SearchSelect.css";
import { Form } from "react-bootstrap";

export default function SearchSelect(props) {
  const [focus, setFocus] = useState(false);
  let options = [];
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleCloseMenu = () => setIsMenuOpen(false)
  const handleOpenMenu = () => setIsMenuOpen(true)

  props?.data?.map((item, index) => {
    let option = {};
    if (props.isPatternApplicable) {
      let fields = [
        { propField: "valueField", optionField: "value" },
        { propField: "labelField", optionField: "label" },
      ];
      let prevPattern = "";
      let prevValue = "";

      for (let fld of fields) {
        let fieldData = props[fld.propField];
        if (fieldData === prevPattern) {
          option[fld.optionField] = prevValue;
          break;
        }
        prevPattern = fieldData;
        for (let dt of Object.keys(item)) {
          if (fieldData.includes("{$" + dt + "}")) {
            fieldData = fieldData.replaceAll("{$" + dt + "}", item[dt]);
          }
        }
        option[fld.optionField] = fieldData;
        prevValue = fieldData;
      }
      option.item = item;
    } else if (props.valueField) {
      option.label = item[props.labelField];
      option.value = item[props.valueField];
      option.item = item;
    } else {
      option.value = item;
      option.label = item;
    }
    options.push(option);
  });

  const filterOption = createFilter({ matchFrom: 'start' });

  const validateInput = () => {
    setFocus(false);
    allValidations();
  };

  const validateMandatory = () => {
    if (!props.value || props.value === "") {
      if (!props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields &&
          props.setMandatoryFields((prev) => [...prev, props.name]);
      }
      return props.label + " is mandatory";
    } else {
      let mandatoryFieldsTemp = props.mandatoryFields;
      if (mandatoryFieldsTemp?.length > 0) {
        const index = mandatoryFieldsTemp?.indexOf(props.name);
        if (index > -1) {
          mandatoryFieldsTemp.splice(index, 1);
        }
        props.setMandatoryFields &&
          props.setMandatoryFields(mandatoryFieldsTemp);
      }
      return "";
    }
  };

  const allValidations = () => {
    let errorMsg = "";
    if (props.required && !props.readOnly) {
      errorMsg = validateMandatory();
    }
    if (props.value && props.value !== "") {
      if (props.customValidation) {
        errorMsg = props.customValidation(props.value, props.name);
      }
    }
    if (props.setError)
      props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
  };
  useEffect(() => {
    if (
      props.required &&
      !props.value &&
      !props.mandatoryFields?.includes(props.name)
    ) {
      props.setMandatoryFields &&
        props.setMandatoryFields((prev) => [...prev, props.name]);
    }
  }, []);

  useEffect(() => {
    if (props.submit) {
      props.setFieldCount((prev) => [...prev, props.name]);
      allValidations();
    }
  }, [props.submit]);

  return (
    <Form.Group className={`g-input-select`}>
      <Select
        menuPlacement="auto"
        {...props}
        menuPosition={props.menuPositionNotFixed?"absolute":"fixed" }
        classNamePrefix="select"
        className={`${props.error && props.error[props.name] ? "text-field-with-error" : ""}`}
        options={options}
        blurInputOnSelect={false}
        onBlur={validateInput}
        value={props.value ? { label: props.value, value: props.value } : {}}
        filterOption={filterOption}
        formatOptionLabel={(option) => (<>
          {option.item?.ImageToShowInDropDown ? <div className="dropdown-image">
            {option.item[props.additionalLableColumn] && <span className="label-box">
              <span className="label">{option.label} </span>
              <span className="additional-label">{props.additionalLabelStart + "" + option.item[props.additionalLableColumn]}</span>
            </span>}
            {option.item?.ImageToShowInDropDown && ( // Check if path exists for image  
              <img src={option.item.ImageToShowInDropDown} />
            )}
          </div> : option.label}</>
        )}
        isDisabled={props.disabled}
        placeholder=""
        inputId={props.id || props.name}
        onFocus={() => { setFocus(true); setIsMenuOpen(true)} }
        onChange={(opt) => {
          let obj = {
            target: { name: props.name, value: opt.value, item: opt.item, path: opt.item?.path},
          };
          props.onChange(obj);
        }}
        onMenuClose={handleCloseMenu}
        onMenuOpen={handleOpenMenu}
        menuIsOpen={isMenuOpen}
      />
      <Form.Label 
        htmlFor={props.id || props.name} 
        className={`${focus || (props.value && props.value !== "") ? "active" : ""}`}
        onClick={() => {
          const selectInput = document.querySelector(`#${props.id || props.name} input`);
          if (selectInput) {
            selectInput.focus();
          }
        }}
      >
        {props.label}
        {props.optional && <span className="optional"> (optional)</span>}
      </Form.Label>
      {props.error && props.error[props.name] && (
        <Form.Text className="text-danger">{props.error[props.name]}</Form.Text>
      )}
    </Form.Group>
  );
}